<template>
    <section class="ol-hero-slider">
        <a v-for="(path,i) in paths" :key="i" :href="path.link_banner ? path.link_banner : '#'">
            <span class="ol-hero-slider__item">
                <img :src="path.web" alt=""  class="ol-hero-slider__item-img--desktop">
                <img :src="path.mobile" alt=""  class="ol-hero-slider__item-img--mobile">
            </span>
        </a>
    </section>
</template>

<script>
require('../../assets/js/slick/slick.min.js')
export default {
    name:"SlideCarousel",
    props:["paths"],
    updated: function () {
        this.$nextTick(function () {
            $(".ol-hero-slider").slick({
                    slidesToScroll: 1,
                    slidesToShow: 1,
                    dots: !0,
                    autoplay: !0,
                    autoplaySpeed: 5e3,
                    arrows: !0,
                    pauseOnFocus: !1,
                    responsive: [{
                        breakpoint: 481,
                        settings: {
                            arrows: !1
                        }
                    }]
            });
        })
    }
}
</script>

<style>
    @import "../../assets/js/slick/slick.css";
</style>